<aside>
  @if (session) {
  <div class="wrapper">
    <fa-icon class="c-error" [icon]="faStopwatch"></fa-icon>
    <div class="info">
      <span i18n class="t-small">Duration</span>
      <span>{{ session.start | dateInterval : session.end }}</span>
    </div>
  </div>

  <div class="wrapper">
    <fa-icon class="c-error" [icon]="faClendarTimes"></fa-icon>
    <div class="info">
      <span i18n class="t-small">Booking Deadline</span>
      <span>{{ session.deadline | date }}</span>
    </div>
  </div>
  }
  <p class="total m-t-32 m-b-32">
    <span>Total</span>
    <strong class="t-large">{{ total }} {{ tour.currency | uppercase }}</strong>
  </p>
  @if (form) {
  <form [formGroup]="form">
    <un-input
      type="select"
      [options]="sessions"
      label="Session"
      formControlName="session"
      placeholder="Choose session date"
      i18n-placeholder
      [showClearIcon]="false"
    ></un-input>
    <un-passangers-input
      placeholder="Choose guest"
      formControlName="guest"
    ></un-passangers-input>
  </form>
  } @if (!auth.isInstituteUser) {
  <div class="actions">
    <un-button
      [fullwidth]="true"
      [disabled]="!total"
      i18n
      size="large"
      type="primary"
      (btnClick)="book()"
      >Book</un-button
    >
  </div>
  } @if (auth.isAdmin || auth.isInstituteUser) {
  <div class="actions">
    <un-button
      size="large"
      type="primary"
      [link]="[RoutePath.dashboardTours, tour._id, RoutePath.edit]"
    >
      <un-icon type="form" theme="outline"></un-icon>
      <span i18n="@@edit">Edit</span>
    </un-button>
  </div>
  }
</aside>
<ng-template #unknownTmp>
  <span i18n="@@unknown">Unknown</span>
</ng-template>
